import { makeStyles } from '@mui/styles';
import Tab from 'apollo-react/components/Tab';
import Tabs from 'apollo-react/components/Tabs';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setOpenErrorsTabCertification } from '../../actions/CertificationActions';
import { setPanelLayoutConfig } from '../../actions/PanelLayoutActions';
import ErrorDisplay from '../../components/ErrorDisplay';
import {
  LEFT_PANEL_COLLAPSE_EXPAND_MAP,
  LEFT_PANEL_EXPAND_COLLAPSE_MAP,
} from '../../constants/PanelLayoutConstants';
import { usePrevious } from '../../custom-hooks';
import { equalityFn } from '../../form-designer/utils/form-manager.utils';
import { getErrorDisplayMessages } from '../../selectors/MessagesSelectors';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'transparent',
    padding: '0px 10px',
    height: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  tabs: {
    marginBottom: 20,
  },
});

const LeftPanel = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const errors = useSelector(getErrorDisplayMessages, equalityFn);
  const panelConfig = useSelector((state) => state.panelLayout.config);
  const openErrorsTab = useSelector((state) => state.certification.openErrorsTab);
  const previousErrorsCount = usePrevious(errors.length);

  const openPanel = () => {
    const newConfig = LEFT_PANEL_COLLAPSE_EXPAND_MAP[panelConfig];

    if (!_.isNil(newConfig)) {
      dispatch(setPanelLayoutConfig(newConfig));
    }
  };

  const closePanel = () => {
    const newConfig = LEFT_PANEL_EXPAND_COLLAPSE_MAP[panelConfig];

    if (!_.isNil(newConfig)) {
      dispatch(setPanelLayoutConfig(newConfig));
    }
  };

  useEffect(() => {
    if (previousErrorsCount !== errors.length) {
      if (errors.length > 0) {
        openPanel();
      } else {
        closePanel();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  useEffect(() => {
    if (panelConfig in LEFT_PANEL_COLLAPSE_EXPAND_MAP && openErrorsTab) {
      openPanel();
      dispatch(setOpenErrorsTabCertification(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openErrorsTab]);

  return (
    <div className={classes.root} ui-ta="ScrollingElement">
      <Tabs className={classes.tabs} value={0}>
        <Tab label={`Errors (${errors.length})`} disabled={errors.length < 1} />
      </Tabs>
      <ErrorDisplay />
    </div>
  );
};

export default LeftPanel;
